/** Asia/Bangkok — no DST. Used for popup "don't show again until next day HH:MM". */
export const POPUP_RESHOW_TZ = 'Asia/Bangkok'
export const DEFAULT_POPUP_RESHOW_DAILY_AT = '00:00'

const BANGKOK_OFFSET_MS = 7 * 60 * 60 * 1000

export function normalizeReshowDailyAt(value?: string | null): string {
  const raw = String(value || '').trim()
  const match = raw.match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return DEFAULT_POPUP_RESHOW_DAILY_AT
  const hour = Math.min(23, Math.max(0, parseInt(match[1], 10)))
  const minute = Math.min(59, Math.max(0, parseInt(match[2], 10)))
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

function bangkokDateParts(date: Date): { year: number; month: number; day: number } {
  const key = new Intl.DateTimeFormat('en-CA', {
    timeZone: POPUP_RESHOW_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
  const [year, month, day] = key.split('-').map(Number)
  return { year, month, day }
}

/**
 * Next Bangkok calendar day at HH:MM (always "tomorrow" relative to `from`).
 * Example: dismiss Fri 18:00 with 00:00 → Sat 00:00 Bangkok.
 */
export function computeNextReshowUntil(
  reshowDailyAt?: string | null,
  from: Date = new Date()
): Date {
  const normalized = normalizeReshowDailyAt(reshowDailyAt)
  const [hour, minute] = normalized.split(':').map(Number)
  const { year, month, day } = bangkokDateParts(from)
  return new Date(Date.UTC(year, month - 1, day + 1, hour, minute, 0, 0) - BANGKOK_OFFSET_MS)
}

export function isDismissUntilActive(untilIso: string | null | undefined, now: Date = new Date()): boolean {
  if (!untilIso) return false
  const untilMs = Date.parse(untilIso)
  if (!Number.isFinite(untilMs)) return false
  return now.getTime() < untilMs
}
